import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RoomsFacade } from '@library/store/rooms/rooms.facade';
import { isDefined } from '@library/utils/helpers/store/is-defined';
import { CpCompareSidebarService } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';
import { combineLatest, map, startWith, switchMap } from 'rxjs';

@Component({
  selector: 'app-cp-compare-graph-header',
  templateUrl: './cp-compare-graph-header.component.html',
  styleUrls: ['./cp-compare-graph-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CpCompareGraphHeaderComponent {

  private roomName$ = this.compareSidebarService.measureCards$.pipe(
    map(measureCards => measureCards[0]?.module?.room_id ?? measureCards[0]?.room?.id),
    isDefined(),
    switchMap(roomId => this.roomsFacade.rooms$.pipe(
      map(rooms => rooms.find(room => room.id === roomId))),
    ),
    map(room => room?.name),
    startWith('')
  );

  viewModel$ = combineLatest({
    measureCards: this.compareSidebarService.measureCards$,
    roomName: this.roomName$,
  });

  constructor(
    private compareSidebarService: CpCompareSidebarService,
    private roomsFacade: RoomsFacade,
  ) {}

}
